import * as yup from 'yup';

export const validateProfileUpdate = () => {
  const phoneRegExp =
    /^((\+[1-9]{1,4}[ -]?)|(\([0-9]{2,3}\)[ -]?)|([0-9]{2,4})[ -]?)*?[0-9]{3,4}[ -]?[0-9]{3,4}$/;
  const validationSchema = yup.object().shape({
    fName: yup
      .string()
      .required('This field is required')
      .matches(/^[A-Za-z]*$/, 'Please enter a valid name'),
    lName: yup
      .string()
      .required('This field is required')
      .matches(/^[A-Za-z]*$/, 'Please enter a valid name'),
    gender: yup.string().required('This field is required'),
    dob: yup.string().required('This field is required'),
    maritalStatus: yup.string().required('This field is required'),
    phone: yup
      .string()
      .matches(phoneRegExp, 'Phone number is not valid')
      .required('Admin contact is required'),
    address: yup.string().required('This field is required'),
    city: yup
      .string()
      .required('This field is required')
      .max(45, 'Invalid city name provided. Too long'),
    occupation: yup.string().required('This field is required'),
    currentEmployer: yup.string().required('This field is required'),
    employerAddress: yup.string().required('This field is required'),
    nextOfKin: yup.string().required('This field is required'),
    nextofKinAddress: yup.string().required('This field is required'),
  });

  return validationSchema;
};

export const validateAddBank = () => {
  const validationSchema = yup.object().shape({
    bankName: yup.string().required('Bank name is required'),
    accountName: yup.string().required('Account name is required'),
    accountNumber: yup
      .string()
      .required('Account number is required')
      .min(10, 'Incomplete account number')
      .max(10, 'Account number cannot be more than 10 digits'),
    accountType: yup.string().required('Account type is required'),
  });

  return validationSchema;
};

export const validateWithdraw = () => {
  const validationSchema = yup.object().shape({
    balance: yup.number().required(),
    amount: yup
      .mixed()
      .test('isLarger', 'Amount must be lower than your balance', (value, testContext) => {
        if (testContext.parent.balance <= value) return false;
        return true;
      })
      .required('How much are you withdrawing?'),
    bank: yup.string().required('Kindly select a bank account details to receive the funds to.'),
  });

  return validationSchema;
};
